var map = {
	"./Devil.png": 833,
	"./action.png": 834,
	"./adventure.png": 835,
	"./alien.PNG": 836,
	"./animal.png": 837,
	"./anvil.png": 838,
	"./armor.png": 839,
	"./beer.png": 840,
	"./castle.png": 841,
	"./cat.png": 842,
	"./character.png": 843,
	"./city.png": 844,
	"./clover.png": 845,
	"./crown.png": 846,
	"./currency.png": 847,
	"./description.png": 848,
	"./dice.png": 849,
	"./dictator.png": 850,
	"./die.png": 851,
	"./dog.png": 852,
	"./drink.png": 853,
	"./dungeon.png": 854,
	"./dwarf.png": 855,
	"./encounter.png": 856,
	"./enemy.png": 857,
	"./fantasy.png": 858,
	"./fish.png": 859,
	"./food.png": 860,
	"./formal.png": 861,
	"./fortress.png": 862,
	"./friend.png": 863,
	"./generator.png": 864,
	"./ghost.png": 865,
	"./gold.png": 866,
	"./hammer.png": 867,
	"./hydra.png": 868,
	"./item.png": 869,
	"./key.png": 870,
	"./king.png": 871,
	"./kraken.png": 872,
	"./lock.png": 873,
	"./magic.png": 874,
	"./money.png": 875,
	"./monster.png": 876,
	"./mummy.png": 877,
	"./mushroom.png": 878,
	"./name.png": 879,
	"./noble.png": 880,
	"./npc.png": 881,
	"./person.png": 882,
	"./place.png": 883,
	"./plant.png": 884,
	"./potion.png": 885,
	"./rank.png": 886,
	"./reward.png": 887,
	"./room.png": 888,
	"./salami.png": 889,
	"./sea.png": 890,
	"./set.png": 891,
	"./simple.png": 892,
	"./soldier.png": 893,
	"./space.png": 894,
	"./spell.png": 895,
	"./standard.png": 156,
	"./sun.png": 896,
	"./sushi.png": 897,
	"./sword.png": 898,
	"./table.png": 899,
	"./template.png": 900,
	"./test.png": 901,
	"./title.png": 902,
	"./troll.png": 903,
	"./trophy.png": 904,
	"./vampire.png": 905,
	"./viking.png": 906,
	"./village.png": 907,
	"./villain.png": 908,
	"./wolf.png": 909
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 307;


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards ^\.\/.*$
// module id = 307
// module chunks = 53